var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditArchive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 8,
    fill: "#F57C1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.83301H8.99998C8.55795 9.83301 8.13403 10.0086 7.82147 10.3212C7.50891 10.6337 7.33331 11.0576 7.33331 11.4997V18.9997C7.33331 19.4417 7.50891 19.8656 7.82147 20.1782C8.13403 20.4907 8.55795 20.6663 8.99998 20.6663H16.5C16.942 20.6663 17.3659 20.4907 17.6785 20.1782C17.9911 19.8656 18.1666 19.4417 18.1666 18.9997V16.4997",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16.4995H14L21.0833 9.4162C21.4149 9.08468 21.6011 8.63505 21.6011 8.1662C21.6011 7.69736 21.4149 7.24772 21.0833 6.9162C20.7518 6.58468 20.3022 6.39844 19.8333 6.39844C19.3645 6.39844 18.9149 6.58468 18.5833 6.9162L11.5 13.9995V16.4995Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 8.16699L19.8333 10.667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditArchive);
export default __webpack_public_path__ + "static/media/edit-archive.ed9ac1434eb94dbbe73a68e1803ae43a.svg";
export { ForwardRef as ReactComponent };